import { motion } from "framer-motion";

function AnimationMain() {
    return (
        <motion.svg
            width="514"
            height="476"
            viewBox="0 0 514 476"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* _____________________________neck */}
            <motion.g
                animate={{
                    transform: [
                        "matrix(0.9998, 0.0175, -0.0175, 0.9998, 2.5358, -1.5794)",
                        "matrix(0.9994, 0.0349, -0.0349, 0.9994, 5.0989, -3.1144)",
                        "matrix(0.9994, 0.0349, -0.0349, 0.9994, 5.0989, -3.1144)",
                        "matrix(0.9998, 0.0175, -0.0175, 0.9998, 2.5358, -1.5794)",
                        "matrix(0.9998, -0.0175, 0.0175, 0.9998, -2.5079, 1.6234)",
                        "matrix(0.9994, -0.0349, 0.0349, 0.9994, -4.9871, 3.2904)",
                        "matrix(0.9998, -0.0175, 0.0175, 0.9998, -2.5079, 1.6234)",
                        "matrix(0.9998, 0.0175, -0.0175, 0.9998, 2.5358, -1.5794)",
                    ],
                }}
                transition={{ repeat: Infinity, duration: 10 }}
            >
                <path d="M263.5 272V202H329L335.5 272H263.5Z" fill="#EEA986" stroke="black" />
                <path
                    d="M264 240.5V214C275.5 217.833 302.4 226.4 318 230C299 259 276 243.167 264 240.5Z"
                    fill="black"
                    stroke="black"
                />
            </motion.g>

            {/* _____________________________hand */}
            <motion.g
                animate={{
                    transform: [
                        "matrix(0.9998, 0.0175, -0.0175, 0.9998, 2.0569, -1.6984)",
                        "matrix(0.9986, 0.0523, -0.0523, 0.9986, 6.2581, -4.9864)",
                        "matrix(0.9962, 0.0872, -0.0872, 0.9962, 10.5714, -8.1257)",
                        "matrix(0.9925, 0.1219, -0.1219, 0.9925, 14.9917, -11.1125)",
                        "matrix(0.9877, 0.1564, -0.1564, 0.9877, 19.5136, -13.9433)",
                        "matrix(0.9925, 0.1219, -0.1219, 0.9925, 14.9917, -11.1125)",
                        "matrix(0.9962, 0.0872, -0.0872, 0.9962, 10.5714, -8.1257)",
                        "matrix(0.9986, 0.0523, -0.0523, 0.9986, 6.2581, -4.9864)",
                        "matrix(0.9998, 0.0175, -0.0175, 0.9998, 2.0569, -1.6984)",
                        "matrix(0.9998, -0.0175, 0.0175, 0.9998, -2.0270, 1.7341)",
                        "matrix(0.9986, -0.0523, 0.0523, 0.9986, -5.9885, 5.3071)",
                        "matrix(0.9962, -0.0872, 0.0872, 0.9962, -9.8230, 9.0161)",
                        "matrix(0.9986, -0.0523, 0.0523, 0.9986, -5.9885, 5.3071)",
                        "matrix(0.9998, -0.0175, 0.0175, 0.9998, -2.0270, 1.6984)",
                        "matrix(0.9998, 0.0175, -0.0175, 0.9998, 2.0569, -1.6984)",
                    ],
                }}
                transition={{ repeat: Infinity, duration: 3 }}
            >
                <path
                    d="M131 288L135.5 297.5L96.5 307C96.1667 307.833 95.3 307.6 94.5 300C93.5 290.5 50.5 247 44 237.5C38.8 229.1 46.1667 230.333 50.5 232L66.5 242C62.6667 236.833 53.8 224.2 49 215C45.8 205.8 52.6667 206.333 56.5 208L78.5 232C74.5 224.333 65.6 207.3 62 200.5C60.4 191.3 66.6667 193.333 70 195.5L92.5 226.5C88.8333 219.5 81.3 203.8 80.5 197C79.5 188.5 86 189.5 89.5 192.5C113.1 243.3 123 245.333 125 240L133 215C134.333 215.167 136.7 214.5 139.5 218.5C143 223.5 137 254 133 267.5C128.2 276.3 129.667 284.833 131 288Z"
                    fill="#EEA986"
                    stroke="black"
                />
                <path
                    d="M82.5 259.5L106 239.5M117.5 245.5C112.167 250 104.7 262.3 117.5 275.5"
                    stroke="black"
                />
            </motion.g>

            {/* _____________________________body */}
            <motion.g>
                <path
                    d="M129 435.5C138.6 285.9 221 245.167 261 243.5C301 292 327 253 333.5 243.5C434.7 248.7 468 373.667 472 435.5H129Z"
                    fill="#568ED5"
                    stroke="black"
                />
                <path
                    d="M189.5 283L193 307M195 321C197.667 350.5 203 414.7 203 435.5M405 281C402.667 290.5 397.1 325.4 393.5 389M391 424L392.5 399.5"
                    stroke="black"
                />
            </motion.g>

            {/* _____________________________arm */}
            <motion.path
                animate={{
                    transform: [
                        "matrix(0.9998, 0.0175, -0.0175, 0.9998, 2.5358, -1.5794)",
                        "matrix(0.9994, 0.0349, -0.0349, 0.9994, 5.0989, -3.1144)",
                        "matrix(0.9986, 0.0523, -0.0523, 0.9986, 7.6883, -4.6043)",
                        "matrix(0.9994, 0.0349, -0.0349, 0.9994, 5.0989, -3.1144)",
                        "matrix(0.9998, 0.0175, -0.0175, 0.9998, 2.5358, -1.5794)",
                        "matrix(0.9998, -0.0175, 0.0175, 0.9998, -2.5079, 1.6234)",
                        "matrix(0.9994, -0.0349, 0.0349, 0.9994, -4.9871, 3.2904)",
                        "matrix(0.9998, -0.0175, 0.0175, 0.9998, -2.5079, 1.6234)",
                        "matrix(0.9998, 0.0175, -0.0175, 0.9998, 2.5358, -1.5794)",
                    ],
                }}
                transition={{ repeat: Infinity, duration: 3 }}
                d="M94.2839 303.724C88.3364 305.669 92.5219 395.552 95 438.5L183 435L140.872 294C127.821 296.431 100.231 301.779 94.2839 303.724Z"
                fill="#568ED5"
                stroke="black"
            />
            {/* _____________________________HADE */}
            <motion.g
                animate={{
                    transform: [
                        "matrix(0.9998, 0.0175, -0.0175, 0.9998, 2.5358, -1.5794)",
                        "matrix(0.9994, 0.0349, -0.0349, 0.9994, 5.0989, -3.1144)",
                        "matrix(0.9994, 0.0349, -0.0349, 0.9994, 5.0989, -3.1144)",
                        "matrix(0.9998, 0.0175, -0.0175, 0.9998, 2.5358, -1.5794)",
                        "matrix(0.9998, -0.0175, 0.0175, 0.9998, -2.5079, 1.6234)",
                        "matrix(0.9994, -0.0349, 0.0349, 0.9994, -4.9871, 3.2904)",
                        "matrix(0.9998, -0.0175, 0.0175, 0.9998, -2.5079, 1.6234)",
                        "matrix(0.9998, 0.0175, -0.0175, 0.9998, 2.5358, -1.5794)",
                    ],
                }}
                transition={{ repeat: Infinity, duration: 10 }}
            >
                {/* _____________________________face */}
                <path
                    d="M346.5 188C324.5 235.2 304.333 241.667 297 239C275 241.5 253.5 209 244.5 191.5C237.5 165.5 237.5 152.5 244.5 107C266.5 47 300.5 60 325 65.5C366 80 353.958 172 346.5 188Z"
                    fill="#EEA986"
                    stroke="black"
                />
                <path
                    d="M321 167.705C322 160.704 332.5 152.704 343.5 162.705C342 168.704 332 177.204 321 167.705Z"
                    fill="#E48578"
                />
                <path
                    d="M247.128 162.409C251.489 156.843 264.581 155.153 269.12 169.309C264.825 173.759 251.916 176.132 247.128 162.409Z"
                    fill="#E48578"
                />
                {/* ______eyes */}
                <path
                    d="M309 138C312.667 133.167 323 126 335 136C326.5 138 330 141 309 138Z"
                    fill="white"
                    stroke="black"
                />
                <motion.path
                    animate={{ x: [0, -0.3, -0.4, -0.6, -0.6, -0.6, -0.4, -0.3, 0, 0] }}
                    transition={{ repeat: Infinity, duration: 5 }}
                    d="M321 139C315.8 136.2 317.833 132.833 319.5 131.5C321 130.5 325 131 327 131.5C329.4 134.7 326.667 137.833 325 139H321Z"
                    fill="#568ED5"
                    stroke="black"
                />
                <path
                    d="M253.5 137.5C256.833 132.833 266.8 126.3 280 137.5C271 139 269.5 143 253.5 137.5Z"
                    fill="white"
                    stroke="black"
                />
                <motion.path
                    animate={{ x: [0, -0.3, -0.4, -0.6, -0.6, -0.6, -0.4, -0.3, 0, 0] }}
                    transition={{ repeat: Infinity, duration: 5 }}
                    d="M264.5 140C259.7 136.4 261.5 133.333 263 132C265 132 269.5 131.7 271.5 132.5C274.3 134.9 271.333 138.5 269.5 140H264.5Z"
                    fill="#4073B5"
                    stroke="black"
                />
                <motion.circle
                    animate={{
                        x: [0, -0.3, -0.4, -0.6, -0.6, -0.6, -0.4, -0.3, 0, 0],
                        y: [0, 0.3, 0.4, 0.6, 0.6, 0.6, 0.4, 0.3, 0, 0],
                    }}
                    transition={{ repeat: Infinity, duration: 8 }}
                    cx="266.5"
                    cy="135.5"
                    r="1.5"
                    fill="black"
                />
                <motion.circle
                    animate={{
                        x: [0, -0.3, -0.4, -0.6, -0.6, -0.6, -0.4, -0.3, 0, 0],
                        y: [0, 0.3, 0.4, 0.6, 0.6, 0.6, 0.4, 0.3, 0, 0],
                    }}
                    transition={{ repeat: Infinity, duration: 8 }}
                    cx="322.5"
                    cy="134.5"
                    r="1.5"
                    fill="black"
                />
                {/* ______hair */}
                <path
                    d="M241.5 176C239.5 175.333 235.2 173.5 234 171.5C232.5 169 230.5 160.5 226.5 159C224.5 155 222.667 148.667 222 146L218.5 140L220 136H217L218.5 120.5C217.537 120.901 216.04 121.635 214.613 122.556C211.883 125.619 210.056 127.887 211 126C211.622 124.756 213.077 123.548 214.613 122.556C216.222 120.751 218.146 118.669 220 117C222 109 231 85 232.5 83.5C233.7 82.3 224.667 88.3333 220 91.5C223.333 88.6667 230.8 82.4 234 80C237.2 77.6 239.333 73 240 71L220 86.5C225.833 80.6667 238.3 68.7 241.5 67.5C245.5 66 253.5 57 256.5 55C259.5 53 265.5 49.5 270 48.5C274.5 47.5 284.5 45 288 43.5C291.5 42 299.5 40.5 303 42C306.5 43.5 315 43.5 320 46C325 48.5 336.5 52.5 342 58.5C346.4 63.3 356.833 76.1667 361.5 82L368 93.75L374.5 105.5L368 97.5L377 111L369.5 103.5C368.3 102.3 375.333 112 379 117L372.5 111L381.5 128L372.5 117L379 128L372.5 123.5L381.5 138.5L374.5 130C373.667 133.667 372.5 142.4 374.5 148C376.5 153.6 377 159.333 377 161.5L369.5 146C368.833 149.333 366.9 157.1 364.5 161.5C362.1 165.9 357.5 175.667 355.5 180C355.667 177.333 356.3 171.4 357.5 169C358.7 166.6 351.333 175.333 347.5 180L349.5 161.5C350.167 155 351.1 140.8 349.5 136C347.9 131.2 347.5 113.667 347.5 105.5C347.167 100 345.2 87.2 340 80C333.5 71 323.5 63 320 63.5C317.2 63.9 303.5 73.3333 297 78L256.5 105.5C251.833 108.833 242 119.6 240 136C238 152.4 240.167 169.5 241.5 176Z"
                    fill="#2F0C08"
                />
                <path
                    d="M241.5 176C239.5 175.333 235.2 173.5 234 171.5C232.5 169 230.5 160.5 226.5 159C224.5 155 222.667 148.667 222 146L218.5 140L220 136H217L218.5 120.5C216.5 121.333 212.2 123.6 211 126C209.5 129 215 121.5 220 117C222 109 231 85 232.5 83.5C233.7 82.3 224.667 88.3333 220 91.5C223.333 88.6667 230.8 82.4 234 80C237.2 77.6 239.333 73 240 71L220 86.5C225.833 80.6667 238.3 68.7 241.5 67.5C245.5 66 253.5 57 256.5 55C259.5 53 265.5 49.5 270 48.5C274.5 47.5 284.5 45 288 43.5C291.5 42 299.5 40.5 303 42C306.5 43.5 315 43.5 320 46C325 48.5 336.5 52.5 342 58.5C346.4 63.3 356.833 76.1667 361.5 82L368 93.75L374.5 105.5L368 97.5L377 111C375 109 370.7 104.7 369.5 103.5C368.3 102.3 375.333 112 379 117L372.5 111L381.5 128L372.5 117L379 128L372.5 123.5L381.5 138.5L374.5 130C373.667 133.667 372.5 142.4 374.5 148C376.5 153.6 377 159.333 377 161.5L369.5 146C368.833 149.333 366.9 157.1 364.5 161.5C362.1 165.9 357.5 175.667 355.5 180C355.667 177.333 356.3 171.4 357.5 169C358.7 166.6 351.333 175.333 347.5 180L349.5 161.5C350.167 155 351.1 140.8 349.5 136C347.9 131.2 347.5 113.667 347.5 105.5C347.167 100 345.2 87.2 340 80C333.5 71 323.5 63 320 63.5C317.2 63.9 303.5 73.3333 297 78L256.5 105.5C251.833 108.833 242 119.6 240 136C238 152.4 240.167 169.5 241.5 176Z"
                    stroke="black"
                />
                {/* ______eyebrow */}
                <path
                    d="M279.5 126.5C266.3 120.1 250.667 126.167 244.5 130V126.5C253 117.5 262 119 267.5 118.5C271.9 118.1 278.667 120.333 281.5 121.5C281.333 122.5 280.7 124.9 279.5 126.5Z"
                    fill="#2F0C08"
                />
                <path
                    d="M309 125C303 124.2 307.167 120.333 310 118.5C349 114.5 346 129 344.5 129C335.526 120.026 317.107 123.48 309.07 124.987L309 125Z"
                    fill="#2F0C08"
                />
                {/* ______mouth */}
                <path
                    d="M324 183.5C302.8 189.9 277.833 186.167 268 183.5L275.5 187C293.1 215.8 310.5 199 317 187C318.167 186.5 321.2 185.1 324 183.5Z"
                    fill="black"
                    stroke="black"
                />
                <path
                    d="M285 198.5C289.167 195.833 299.2 192.1 308 198.5C305 200.5 294 207 285 198.5Z"
                    fill="#E48578"
                />
                <path
                    d="M278 189.5V185.5C300 188.3 311.5 186 315.5 185.5C315.333 186.333 315.2 187.9 314 189.5C301.2 192.7 284.667 190.833 278 189.5Z"
                    fill="#EAEAEA"
                />
                {/* ______nose */}
                <path
                    d="M279 158C276.333 159.667 272.8 164.2 280 169M280 166.5C281.833 166.333 287.5 166 293 171.5C298 172.5 301.5 165.5 309.5 166.5C312 166.167 315.8 164 311 158"
                    stroke="black"
                />
            </motion.g>
        </motion.svg>
    );
}

export default AnimationMain;
